import { useRouter } from 'next/router';
import React from 'react';

import { Button } from '@sravni/react-design-system';
import { createReviewLink, TProductTypes } from '@sravni/utils/lib/createReviewLink';

import { getAnalyticsObject, sendWriteReviewEvent } from '../../helpers/analyticsEvents';
import { getReviewType } from '../../helpers/reviews';
import { useProductsTags } from '../../store/hooks/filters';
import { useOrganizationDetails } from '../../store/hooks/organizations';
import { TReviewListQuery } from '../../types/router';

import styles from './create-review-button.module.scss';

type TProps = {
  isMobile: boolean;
};

export const CreateReviewButton: React.FC<TProps> = ({ isMobile }) => {
  const router = useRouter() as TRouter<TReviewListQuery>;
  const {
    query: { type, organization, product, reviewObjectId, tag, specificProduct },
  } = router;

  const { name, status, id } = useOrganizationDetails(organization);
  const products = useProductsTags();
  const { typeForService } = getReviewType(type, products);

  const link = createReviewLink({
    organizationType: typeForService,
    organizationId: id || reviewObjectId,
    productTag: (product || tag) as TProductTypes,
    productId: specificProduct,
  });

  const gaObj = getAnalyticsObject(name, type, products, 'Боковой блок');

  const sendEvent = () => {
    sendWriteReviewEvent(gaObj);
  };

  return !status || status === 'active' ? (
    <a onClick={sendEvent} className={styles.link} href={link}>
      <Button size={isMobile ? 44 : 52} variant={'primary'} block>
        Написать отзыв
      </Button>
    </a>
  ) : null;
};
